import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { PageLoading } from "components/Layout";

const Onboarding = React.lazy(() => import("./views/Onboarding"));

export default function OnboardingRoutes() {
  const { path } = useRouteMatch();

  return (
    <React.Suspense fallback={<PageLoading />}>
      <Switch>
        <Route path={path}>
          <Onboarding />
        </Route>
      </Switch>
    </React.Suspense>
  );
}
